module.exports = __webpack_public_path__ + "img/brand.b18a5521.svg";